import React from 'react'
import NewCaseField from '../shared/NewCaseField'

function UpdateProfile({classes}) {
    return (
        <div style={{display:"flex",justifyContent:"space-between"}}>
              <div style={{flex:"1"}}>
                      <div className={classes.parent} style={{marginTop:"8vh"}}>
                        <NewCaseField label={"User name"} required={true} disabled={true} type={"text"} name={"user_name"}/>
                      </div>
                      <div className={classes.parent} >
                      <NewCaseField label={"Given name"} required={true}  type={"text"} name={"user_details.given_name"}/>
                    </div>
                    <div className={classes.parent} >
                    <NewCaseField label={"Family name"}  required={true} type={"text"} name={"user_details.family_name"}/>
                  </div>
                  <div className={classes.parent} >
                  <NewCaseField label={"Email"} required={true}  type={"text"} disabled={true} name={"user_details.email"} isEmail={"true"}/>
                  </div>
                </div>


              <div style={{flex:"1"}}>
                      <div className={classes.parent} style={{marginTop:"8vh"}}>
                    <NewCaseField label={"Address"} required={true}  type={"text"} name={"user_details.address"} placeHolder={"line 1"}/>
                      </div>
                      <div className={classes.parent} >
                        <NewCaseField  type={"text"} name={"user_details.address2"} placeHolder={"line 2"}/>
                      </div>

                      <div className={classes.parent} >
                    <NewCaseField label={"PINo"} type={"text"} name={"user_details.custom:PINo"}/>

                        </div>


                        <div className={classes.parent} >
                    <NewCaseField  label={"Is Admin"}  name={"user_details.custom:Admin"} disabled={true}  />

                  </div>
              </div>


              </div>
    )
}

export default UpdateProfile
